<template>
	<svg :class="svgClass" aria-hidden="true" :style="fill" class="demo">
		<use :xlink:href="iconClassName" class="svg-style" />
	</svg>
</template>
<script setup lang="ts">
import { computed } from 'vue'
const props = defineProps({
	iconName: {
		type: String,
		required: true
	},
	className: {
		type: String,
		default: ''
	},
	color: {
		type: String,
		default: 'rgba(255, 213, 144, 1)'
	},
	hoverColor: {
		type: String,
		default: ''
	}
})
// 图标在 iconfont 中的名字
const iconClassName = computed(() => {
	return `#${props.iconName}`
})
// 给图标添加上类名
const svgClass = computed(() => {
	if (props.className) {
		return `svg-icon ${props.className}`
	}
	return 'svg-icon'
})

const fill = computed(() => {
	return {
		'--fill-color': props.color,
		'--hover-fill-color': props.hoverColor ? props.hoverColor : props.color
	}
})
</script>
<style scoped lang="less">
.svg-icon {
	width: 1em;
	height: 1em;
	position: relative;
	fill: currentColor;
	vertical-align: -2px;
}
.demo {
	--fill: var(--fill-color);
	&:hover {
		--fill: var(--hover-fill-color);
	}
}
.svg-style {
	width: 100%;
	height: 100%;
	fill: var(--fill);
}
</style>
